// extracted by mini-css-extract-plugin
module.exports = {"all":"e_mq","accent":"e_nq"};